import { poll } from './poll'

export const scrollToHashElement = () => {
    const { hash } = window.location

    if (hash === undefined || hash === '') {
        return
    }

    const pollTest = () => {
        const elementToScroll = document.getElementById(hash?.replace('#', ''))
        const hasElement = elementToScroll && elementToScroll.offsetTop !== 0
        return hasElement
    }

    const jumpToElement = () => {
        const elementToScroll = document.getElementById(hash?.replace('#', ''))
        window.scrollTo({
            top: elementToScroll.offsetTop,
        })
    }

    poll(pollTest, 3000, jumpToElement)
}

export const generateIdForHeading = (text: string): string => {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9 -]/gi, '')
        .replace(/\s+/g, '-')
}
